import { create } from 'zustand';

const useAppStore = create((set) => ({
  // State
  appStatus: 'loading',
  settings: null,
  personalizationActive: false,
  pricingTriggered: false,
  // Whether the server honoured a ?mode=preview request. null until the
  // data-versions call answers; false means preview was asked for and
  // refused, which the user needs telling about.
  previewGranted: null,

  // Actions
  setAppStatus: (appStatus) => set({ appStatus }),
  setSettings: (settings) => set({ settings }),
  setPreviewGranted: (previewGranted) => set({ previewGranted }),
  setPersonalizationActive: (personalizationActive) => set({ personalizationActive }),
  setPricingTriggered: (pricingTriggered) => set({ pricingTriggered }),
}));

export default useAppStore;
